<template>
    <div>
        <InfoPageBlock
            h1="Trademark already registered? Submit your renewal docs."
            stepsLength="8"
            url="/trademark-renewal/confirm"
        ></InfoPageBlock>
    </div>
</template>

<script>
import InfoPageBlock from '@/components/blocks/InfoPageBlock.vue'
import {to_top} from "@/helper";

export default {
    components: {
        InfoPageBlock
    },
    mounted() {
        this.$store.commit('header/setTotal', 0)
        to_top()
    }
}
</script>
